import { slideDown, slideUp, slideStop, isVisible } from 'slide-anim';

const downloadToggles = document.querySelectorAll('.dp__trigger, .dpd__title');
const filterToggles = document.querySelectorAll('.df__filter .df__title');
const filterDisplayToggles = document.querySelectorAll('.dc__trigger, .df__close, .df__button--done');

export default () => {
    if (!downloadToggles) {
        return;
    }

    const downloadListQuery = window.matchMedia('(max-width: 768px)');
    responsiveEventListeners(downloadListQuery);
    downloadListQuery.addListener(responsiveEventListeners);

    filterDisplayToggles.forEach((el) => {
        el.addEventListener('click', toggleFilter);
    });
};

function responsiveEventListeners(query) {
    if (query.matches) {
        downloadToggles.forEach((el) => {
            el.removeEventListener('click', toggleSlideDownDownloads);
            el.addEventListener('click', toggleFullScreenDownloads);
        });
        filterToggles.forEach((el) => {
            el.removeEventListener('click', toggleTerms);
        });
    } else {
        downloadToggles.forEach((el) => {
            el.removeEventListener('click', toggleFullScreenDownloads);
            el.addEventListener('click', toggleSlideDownDownloads);
        });
        filterToggles.forEach((el) => {
            el.addEventListener('click', toggleTerms);
        });
    }
}

const toggleFilter = () => {
    const target = document.querySelector('.downloads__filters');

    target.classList.toggle('is-active');
};

const toggleSlideDownDownloads = (e) => {
    const button = e.currentTarget;
    const target = button.closest('.dp').querySelector('.dp__downloads');

    button.classList.toggle('is-active');

    if (isVisible(target)) {
        slideStop(target);
        slideUp(target);
    } else {
        slideStop(target);
        slideDown(target);
    }
};

const toggleFullScreenDownloads = (e) => {
    const button = e.currentTarget;
    const target = button.closest('.dp').querySelector('.dp__downloads');

    target.classList.toggle('is-active');
};

const toggleTerms = (e) => {
    const button = e.currentTarget;
    const target = button.parentNode.querySelector('.df__terms');

    button.classList.toggle('is-active');

    if (isVisible(target)) {
        slideStop(target);
        slideUp(target, {
            display: 'flex',
        });
    } else {
        slideStop(target);
        slideDown(target, {
            display: 'flex',
        });
    }
};
